import React from "react"

import LayoutHeaderMenu from "../LayoutHeaderMenu/LayoutHeaderMenu"

import LayoutIndustries from "../LayoutIndustries/LayoutIndustries"

import "./plastic.scss"

const Plastic = (props) => {
  const uri = props.uri.split("/")

  const {
    set_metadata,
    text_header_title,
    text_header_description,
    asset_header_picture,
    text_title,
    asset_logo,
    wysiwyg_description,
    set_video,
    arr_cards,
    asset_logo_summary,
    wysiwyg_summary,
  } = props.pageContext.content.plastic

  const siteMetadata = {
    title: set_metadata.text_page_title,
    description: set_metadata.text_page_description,
    meta: [
      {
        name: "keywords",
        content: set_metadata.text_keywords,
      },
    ],
    author: `prodHost`,
  }

  const getVideo = () => {
    let result

    props.pageContext.content.apiVideoData.data.forEach((video) => {
      if (video.description && video.description.includes(set_video.text_video_description)) {
        result = video
      }
    })

    return result
  }

  return (
    <div className="plastic-wrapper">
      <LayoutHeaderMenu
        siteMetadata={siteMetadata}
        header_logo={
          props.pageContext.content.global_values.set_logos
            .asset_prodhost_logo_white_120p
        }
        header_title={text_header_title}
        header_description={text_header_description}
        header_background={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_header_picture.path}`}
        header_shaded
        menu={props.pageContext.menu.entries}
        selected={`${uri[1]}`}
        selected2={`${uri[1]}_${uri[2]}`}
        expanded
        footer={props.pageContext.content.global_values.set_footer}
      >
        <LayoutIndustries
          title={text_title}
          logo={asset_logo}
          description={wysiwyg_description}
          video={getVideo()}
          content={arr_cards}
          summary={wysiwyg_summary}
          summary_logo={asset_logo_summary}
        />
      </LayoutHeaderMenu>
    </div>
  )
}

export default Plastic
